import {LoadPanel} from "devextreme-react";
import React from "react";

interface IProps {
    isLoading: boolean;
    message?: string;
}

export const NFLoadPanel = ({isLoading, message}: IProps) => {
    return (
        <>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.1)"
                visible={isLoading}
                showIndicator={true}
                showPane={true}
                shading={true}
                message={message}
            />
        </>
    )
}